import FormInput from './component'

export default FormInput
